export default function onScrollToSelected(grid, callback) {
	if (callback) {
		grid.bind("custom:onScrollToSelected", callback);
	}
}
